import React, {useState} from 'react';
import './LinhVucNganh.css';

import { useNavigate } from "react-router-dom";

function LinhVucNganh  () {
        const [showPage, setShowPage] = useState(false)
         const [addLinhVuc, setAddLinhVuc] = useState("them-linh-vuc");



             // hàm mở page
    const navigate = useNavigate();

    const openPageAdd = () => {
        navigate("/them-linh-vuc");
    };

    //hàm đóng page
    const cancelPageAdd = () => {
        setShowPage(false)
    }
  
        return (
            <div>
    <div className="quan-ly-linh-vuc-wrapper">

        {/* Tiêu đề */}
        <div className="quan-ly-linh-vuc-header">
            <h2 className="quan-ly-linh-vuc-title">
                Quản lý lĩnh vực ngành Công Thương
            </h2>

            <div className="quan-ly-linh-vuc-breadcrumb">
                <span>Trang chủ</span>
                <span>/</span>
                <span>Quản lý lĩnh vực ngành</span>
                <span>/</span>
                <span>Lĩnh vực ngành</span>
            </div>
        </div>

        {/* Bộ lọc */}
        <div className="quan-ly-linh-vuc-filter-area">

            <div className="quan-ly-linh-vuc-filter-left">

                <div className="quan-ly-linh-vuc-search-box">
                    <input
                        type="text"
                        className="quan-ly-linh-vuc-search-input"
                        placeholder="Tìm kiếm theo mã, tên lĩnh vực..."
                    />
                    <i className="fas fa-search quan-ly-linh-vuc-search-icon"></i>
                </div>

                <div className="quan-ly-linh-vuc-status-box">
                    <span className="quan-ly-linh-vuc-status-label">
                        Trạng thái
                    </span>

                    <select className="quan-ly-linh-vuc-status-select">
                        <option>Tất cả</option>
                    </select>
                </div>

            </div>

            <div className="quan-ly-linh-vuc-filter-right">

                <button className="quan-ly-linh-vuc-import-btn">
                    <i className="fas fa-download"></i>
                    Nhập dữ liệu
                </button>

                <button className="quan-ly-linh-vuc-export-btn">
                    <i className="fas fa-upload"></i>
                    Xuất dữ liệu
                </button>

                <button className="quan-ly-linh-vuc-add-btn" onClick={openPageAdd}>
                    <i className="fas fa-plus"></i>
                    Thêm lĩnh vực
                </button>

            </div>

        </div>

        {/* Bảng dữ liệu */}
        <div className="quan-ly-linh-vuc-table-wrapper">

            <table className="quan-ly-linh-vuc-table">

                <thead>
                    <tr>
                        <th>STT</th>
                        <th>Mã lĩnh vực</th>
                        <th>Tên lĩnh vực</th>
                        <th>Nhóm lĩnh vực</th>
                        <th>Mô tả</th>
                        <th>Trạng thái</th>
                        <th>Thứ tự</th>
                        <th>Ngày tạo</th>
                        <th>Thao tác</th>
                    </tr>
                </thead>

                <tbody>

                    <tr>
                        <td>1</td>
                        <td>LV01</td>
                        <td>Công nghiệp</td>
                        <td>Sản xuất công nghiệp</td>
                        <td>Quản lý lĩnh vực công nghiệp</td>
                        <td>
                            <span className="quan-ly-linh-vuc-active">
                                Hoạt động
                            </span>
                        </td>
                        <td>1</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>2</td>
                        <td>LV02</td>
                        <td>Thương mại</td>
                        <td>Thương mại - Dịch vụ</td>
                        <td>Quản lý hoạt động thương mại</td>
                        <td>
                            <span className="quan-ly-linh-vuc-active">
                                Hoạt động
                            </span>
                        </td>
                        <td>2</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>3</td>
                        <td>LV03</td>
                        <td>Điện lực</td>
                        <td>Năng lượng</td>
                        <td>Quản lý lĩnh vực điện lực</td>
                        <td>
                            <span className="quan-ly-linh-vuc-active">
                                Hoạt động
                            </span>
                        </td>
                        <td>3</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>4</td>
                        <td>LV04</td>
                        <td>Năng lượng</td>
                        <td>Năng lượng</td>
                        <td>Quản lý lĩnh vực năng lượng</td>
                        <td>
                            <span className="quan-ly-linh-vuc-active">
                                Hoạt động
                            </span>
                        </td>
                        <td>4</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>5</td>
                        <td>LV05</td>
                        <td>Xuất nhập khẩu</td>
                        <td>Thương mại - Dịch vụ</td>
                        <td>Quản lý hoạt động xuất nhập khẩu</td>
                        <td>
                            <span className="quan-ly-linh-vuc-active">
                                Hoạt động
                            </span>
                        </td>
                        <td>5</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>6</td>
                        <td>LV06</td>
                        <td>Thị trường trong nước</td>
                        <td>Thương mại - Dịch vụ</td>
                        <td>Quản lý thị trường trong nước</td>
                        <td>
                            <span className="quan-ly-linh-vuc-active">
                                Hoạt động
                            </span>
                        </td>
                        <td>6</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>7</td>
                        <td>LV07</td>
                        <td>Khuyến công</td>
                        <td>Hỗ trợ doanh nghiệp</td>
                        <td>Quản lý hoạt động khuyến công</td>
                        <td>
                            <span className="quan-ly-linh-vuc-active">
                                Hoạt động
                            </span>
                        </td>
                        <td>7</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>8</td>
                        <td>LV08</td>
                        <td>An toàn thực phẩm</td>
                        <td>Quản lý chuyên ngành</td>
                        <td>Quản lý an toàn thực phẩm thuộc ngành</td>
                        <td>
                            <span className="quan-ly-linh-vuc-pause">
                                Tạm dừng
                            </span>
                        </td>
                        <td>8</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>9</td>
                        <td>LV09</td>
                        <td>Tiết kiệm năng lượng</td>
                        <td>Năng lượng</td>
                        <td>Quản lý hoạt động tiết kiệm năng lượng</td>
                        <td>
                            <span className="quan-ly-linh-vuc-active">
                                Hoạt động
                            </span>
                        </td>
                        <td>9</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td>10</td>
                        <td>LV10</td>
                        <td>Xúc tiến thương mại</td>
                        <td>Thương mại - Dịch vụ</td>
                        <td>Quản lý hoạt động xúc tiến thương mại</td>
                        <td>
                            <span className="quan-ly-linh-vuc-active">
                                Hoạt động
                            </span>
                        </td>
                        <td>10</td>
                        <td>15/05/2024 08:30</td>
                        <td>
                            <div className="quan-ly-linh-vuc-action-group">
                                <button><i className="fas fa-pen"></i></button>
                                <button><i className="fas fa-eye"></i></button>
                                <button><i className="fas fa-trash"></i></button>
                            </div>
                        </td>
                    </tr>

                </tbody>

            </table>

        </div>

        {/* Footer */}
        <div className="quan-ly-linh-vuc-footer">

            <div className="quan-ly-linh-vuc-total">
                Hiển thị 1 đến 10 trong tổng số 25 bản ghi
            </div>

            <div className="quan-ly-linh-vuc-pagination">

                <select className="quan-ly-linh-vuc-page-size">
                    <option>10</option>
                </select>

                <button className="quan-ly-linh-vuc-page-active">1</button>
                <button>2</button>
                <button>3</button>
                <button>
                    <i className="fas fa-angle-right"></i>
                </button>

            </div>

        </div>

    </div>






            {/* {
                showPage && (
                    <div
                    className={
                    addLinhVuc === "them-linh-vuc"
                        ? "add-linh-vuc-open-page-add-show"
                        : "add-linh-vuc-open-page-add-hide"
                }
                    >
      <div className="">
      <div className="add-new-linh-vuc-page">

        
        <div className="add-new-linh-vuc-header">
          <h2 className="add-new-linh-vuc-title">Thêm lĩnh vực</h2>

          <div className="add-new-linh-vuc-breadcrumb">
            <span>Trang chủ</span>
            <span>/</span>
            <span>Quản lý lĩnh vực ngành</span>
            <span>/</span>
            <span>Lĩnh vực ngành</span>
            <span>/</span>
            <span>Thêm lĩnh vực</span>
          </div>
        </div>

        
        <div className="add-new-linh-vuc-card">

          <div className="add-new-linh-vuc-body">

           
            <div className="add-new-linh-vuc-left">

              <h4 className="add-new-linh-vuc-section-title">
                Thông tin lĩnh vực
              </h4>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Mã lĩnh vực <span>*</span>
                </label>

                <div className="add-new-linh-vuc-input-wrap">
                  <input
                    type="text"
                    className="add-new-linh-vuc-input"
                    placeholder="Nhập mã lĩnh vực"
                  />
                  <p className="add-new-linh-vuc-note">
                    Mã viết tắt, không trùng với mã lĩnh vực khác (VD: LV01)
                  </p>
                </div>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Tên lĩnh vực <span>*</span>
                </label>

                <input
                  type="text"
                  className="add-new-linh-vuc-input"
                  placeholder="Nhập tên lĩnh vực"
                />
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Nhóm lĩnh vực <span>*</span>
                </label>

                <select className="add-new-linh-vuc-select">
                  <option>-- Chọn nhóm lĩnh vực --</option>
                </select>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Mô tả
                </label>

                <div className="add-new-linh-vuc-textarea-wrap">
                  <textarea
                    className="add-new-linh-vuc-textarea"
                    placeholder="Nhập mô tả lĩnh vực"
                  ></textarea>

                  <span className="add-new-linh-vuc-counter">
                    0/255
                  </span>
                </div>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Thứ tự hiển thị
                </label>

                <div className="add-new-linh-vuc-input-wrap">
                  <input
                    type="number"
                    className="add-new-linh-vuc-input"
                    defaultValue="0"
                  />
                  <p className="add-new-linh-vuc-note">
                    Số thứ tự càng nhỏ hiển thị càng lên đầu
                  </p>
                </div>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Trạng thái <span>*</span>
                </label>

                <div className="add-new-linh-vuc-radio-group">
                  <label className="add-new-linh-vuc-radio">
                    <input type="radio" name="status" defaultChecked />
                    Hoạt động
                  </label>

                  <label className="add-new-linh-vuc-radio">
                    <input type="radio" name="status" />
                    Tạm dừng
                  </label>
                </div>
              </div>

            </div>

           
            <div className="add-new-linh-vuc-right">

              <h4 className="add-new-linh-vuc-section-title">
                Thông tin bổ sung
              </h4>

              <div className="add-new-linh-vuc-form-group ">
                <label className="add-new-linh-vuc-label">
                  Ngày hiệu lực
                </label>

                <div className="add-new-linh-vuc-date-wrap date-hieu-luc">
                  <input
                    type="date"
                    className="add-new-linh-vuc-input  "
                  />
                  <i className="fa-regular fa-calendar-days"></i>
                </div>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Đơn vị quản lý
                </label>

                <select className="add-new-linh-vuc-select">
                  <option>-- Chọn đơn vị --</option>
                </select>
              </div>

              <div className="add-new-linh-vuc-form-group">
                <label className="add-new-linh-vuc-label">
                  Ghi chú
                </label>

                <div className="add-new-linh-vuc-textarea-wrap">
                  <textarea
                    className="add-new-linh-vuc-textarea"
                    placeholder="Nhập ghi chú (nếu có)"
                  ></textarea>

                  <span className="add-new-linh-vuc-counter">
                    0/255
                  </span>
                </div>
              </div>

              <div className="add-new-linh-vuc-guide">

                <div className="add-new-linh-vuc-guide-title">
                 
                  <i className="fa-solid fa-circle-exclamation"></i>
                  Hướng dẫn
                </div>

                <ul className="add-new-linh-vuc-guide-list">
                  <li>
                    Mã lĩnh vực là duy nhất và không thể thay đổi sau khi tạo.
                  </li>
                  <li>
                    Vui lòng chọn đúng nhóm lĩnh vực để dễ dàng quản lý và phân loại.
                  </li>
                  <li>
                    Trạng thái "Tạm dừng" sẽ ẩn lĩnh vực khỏi danh sách sử dụng.
                  </li>
                </ul>

              </div>

            </div>

          </div>

        
          <div className="add-new-linh-vuc-footer">

            <button className="add-new-linh-vuc-back-btn" onClick={cancelPageAdd}>
              <i className="fa-solid fa-arrow-left"></i>
              Quay lại danh sách
            </button>

            <div className="add-new-linh-vuc-footer-right">

              <button className="add-new-linh-vuc-cancel-btn" onClick={cancelPageAdd}>
                Hủy bỏ
              </button>

              <button className="add-new-linh-vuc-save-add-btn">
                <i className="fa-regular fa-floppy-disk"></i>
                Lưu và thêm mới
              </button>

              <button className="add-new-linh-vuc-save-btn">
                <i className="fa-regular fa-floppy-disk"></i>
                Lưu
              </button>

            </div>

          </div>

        </div>

      </div>
    </div>



                    </div>
                )
            } */}


















            </div>
        );
    }

export default LinhVucNganh;